import { render, staticRenderFns } from "./menuConfiguration.vue?vue&type=template&id=9fe3f9a6&scoped=true&"
import script from "./menuConfiguration.vue?vue&type=script&lang=js&"
export * from "./menuConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./menuConfiguration.vue?vue&type=style&index=0&id=9fe3f9a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe3f9a6",
  null
  
)

export default component.exports